import { Route } from '../../../../domain/route/Route';
import { RouteSurvey } from '../../../../domain/route/RouteSurvey';
import { Stop } from '../../../../domain/stops/Stop';

export enum RouteActionType {
  FETCH_ROUTE_SUCCESS = `FETCH_ROUTE_SUCCESS`,
  UPDATE_ROUTE_FAIL = `UPDATE_ROUTE_FAIL`,
  CREATE_DRIVER_SURVEY = `CREATE_DRIVER_SURVEY`,
  SET_SELECTED_STOP = `SET_SELECTED_STOP`,
  SET_REPORT_START = `SET_REPORT_START`,
  SET_EDITING_STOP = `SET_EDITING_STOP`,
  SET_NEXT_STOP_TOP_SCROLL = `SET_NEXT_STOP_TOP_SCROLL`,
}

export interface FetchRouteSuccessAction {
  type: RouteActionType.FETCH_ROUTE_SUCCESS;
  payload?: Route;
}
export interface UpdateRouteFailAction {
  type: RouteActionType.UPDATE_ROUTE_FAIL;
  payload?: Route;
}

export interface CreateDriverSurveyAction {
  type: RouteActionType.CREATE_DRIVER_SURVEY;
  payload?: RouteSurvey;
}

export interface SetSelectedStopAction {
  type: RouteActionType.SET_SELECTED_STOP;
  payload?: string;
}

export interface SetReportStartAction {
  type: RouteActionType.SET_REPORT_START;
  payload: { date: Date | undefined; stopId: string | undefined };
}

export interface SetEditingStopAction {
  type: RouteActionType.SET_EDITING_STOP;
  payload?: Stop;
}

export interface SetNextStopTopScrollAction {
  type: RouteActionType.SET_NEXT_STOP_TOP_SCROLL;
  payload?: number;
}

export type RouteActions =
  | FetchRouteSuccessAction
  | UpdateRouteFailAction
  | CreateDriverSurveyAction
  | SetSelectedStopAction
  | SetReportStartAction
  | SetEditingStopAction
  | SetNextStopTopScrollAction;
